// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1PIww","title":"Info_title__X0qHh","selects":"Info_selects__2DJv3","requiredAsterisk":"Info_requiredAsterisk__3lqcW"};